<div class="row">
  <div class="col-3">
    <sb-card>
      <div card-header [classes]="'no-border'">
        {{'lang.globals.details'|translate}}
      </div>
      <div card-body>
        <div class="row" *ngIf="inventoryAggregation">
          <div class="col-6 mb-3">
            <div class="rounded text-center tw-flex tw-items-center tw-min-w-12"
                 style="height:8rem; font-size: 2rem; display: flex; justify-content: center; flex-direction: column; ">
              <h2>
                <sb-icon icon="stele" [dualColor]="true"></sb-icon>
              </h2>
              <h3 style="font-size: 1.2rem;">{{inventoryAggregation.channels}} Channels</h3>
            </div>
          </div>
          <div class="col-6 mb-3">
            <div class="rounded text-center tw-flex tw-items-center tw-min-w-12"
                 style="height:8rem; font-size: 2rem; display: flex; justify-content: center; flex-direction: column; ">
              <h2>
                <sb-icon icon="location" [dualColor]="true"></sb-icon>
              </h2>
              <h3 style="font-size: 1.2rem;">{{inventoryAggregation.locations}} Standorte</h3>
            </div>
          </div>
          <div class="col-6 mb-3">
            <div class="rounded text-center tw-flex tw-items-center tw-min-w-12"
                 style="height:8rem; font-size: 2rem; display: flex; justify-content: center; flex-direction: column; ">
              <h2>
                <sb-icon icon="screen" [dualColor]="true"></sb-icon>
              </h2>
              <h3 style="font-size: 1.2rem;">{{inventoryAggregation.screens}} Bildschirme</h3>
            </div>
          </div>
          <div class="col-6 mb-3">
            <div class="rounded text-center tw-flex tw-items-center tw-min-w-12"
                 style="height:8rem; font-size: 2rem; display: flex; justify-content: center; flex-direction: column; ">
              <h2>
                <sb-icon icon="playerOnline" [dualColor]="true"></sb-icon>
              </h2>
              <h3 style="font-size: 1.2rem;">{{inventoryAggregation.devices}} Geräte</h3>
            </div>
          </div>
        </div>
        <hr>
        <div>
          <h5>
            {{'lang.globals.settings'|translate}}
          </h5>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="form-group">
              <label>{{'lang.globals.threshold' | translate}}</label>
              <select class="form-select" [(ngModel)]="threshold">
                <option *ngFor="let val of thresholdValues" [ngValue]="val">
                  {{val}}
                </option>
              </select>
            </div>
          </div>
          <div class="col-6 d-flex align-items-end">
            <div class="form-group">
              <sb-comp-dropdown-select
                (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
                (selectedDataEmitter)="update($event, 'PLAYER_CULLS')"
                [singleSelectMode]="true"
                *ngPermissions="permissionService.Permission.cull_list" [dropDownDatatype]="'PLAYER_CULLS'"
                [inputData]="culls" [msOptions]="msCullOptions"
                [selectedInputData]="filteredCulls" [showColumnIcon]="false"
                [showSubmit]="false">
              </sb-comp-dropdown-select>
            </div>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
  <div class="col-9">
    <sb-card>
      <div card-body>
        <!--
        TODO comment in when calendar done
        <sb-comp-calendar-standalone
          [event]="eventEdit" [calendar]="calendar"
          (eventEdit)="retrieveOutput($event)"
          [threshold]="threshold"
          (migrateClick)="lookupEvent($event)"
        ></sb-comp-calendar-standalone>
        -->
      </div>
    </sb-card>
  </div>
</div>
